import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import PluginService from 'services/PluginService';
import { PLUGINS } from '__queries/query-keys';

export const usePluginAppEvents = (
  businessPluginApp: { id?: string; config?: any } | undefined,
  hasOauthServices: boolean
) => {
  const businessPluginAppId = businessPluginApp?.id ?? '';
  const hasKZNFileEverImported = Boolean(
    businessPluginApp?.config?.__kizen_schema_import_etag
  );

  const { data: pluginAppEvents, isLoading } = useQuery({
    // getEvents handles an empty id
    queryFn: () => PluginService.getEvents(businessPluginAppId),
    queryKey: PLUGINS.GET_EVENTS(businessPluginAppId),
    // Pick up OAuth done in another tab
    refetchOnWindowFocus: 'always',
    // OAuth and KZN imports change outside this page
    refetchInterval: hasOauthServices || hasKZNFileEverImported ? 15000 : false,
  });

  const oAuthEvents = useMemo(() => {
    return (
      pluginAppEvents?.events.filter((e: any) =>
        e.resource_path.includes('oauth')
      ) ?? []
    );
  }, [pluginAppEvents]);

  const importEvents = useMemo(() => {
    return (
      pluginAppEvents?.events.filter((e: any) => e.tag.includes('import')) ?? []
    );
  }, [pluginAppEvents]);

  const importErrorEvents = useMemo(() => {
    return importEvents.filter((e: any) => e.event_type === 'error');
  }, [importEvents]);

  const oAuthErrorEvents = useMemo(() => {
    return oAuthEvents.filter((e: any) => e.event_type === 'error');
  }, [oAuthEvents]);

  return {
    isLoading,
    oAuthEvents,
    oAuthErrorEvents,
    importEvents,
    importErrorEvents,
  };
};
